import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import axios from 'axios';
import './CustomerForm.css';
import AuthContext from './AuthContext';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_PROXY_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const NewCustomerForm = () => {
  const { customerId } = useParams();  
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const { dataClient } = useOutletContext();

  const [formData, setFormData] = useState({
    customer_number: '',
    customer_name: '',
    home_page: '',
    limit_access: '',
    title_graphic: '',
    products: '',
    greeting: '',
    pay_tax_message: '',
    disable_message: '',
    county_number: '',
    accept_delinquents: '1',
    current_year_delinquents: 'false',
    import_payment: 'false',
    new_experience: 'false',
    disable_list: '',
    ip_access_list: '',
    taxid_block_list: '',
    paydelq: '',
    active: 'Yes',
    tax_search_message: '',
    payment_gateway: ''
  });

  useEffect(() => {
      // if no user in context, log them in again
      if (!user) {
        navigate('/login');
        return;
      }
      // check expiration
      const currentTime = Date.now() / 1000; // in seconds
      if (user.exp && user.exp <= currentTime) {
        // token has expired
        navigate('/login');
      }
    }, [user, navigate]);

  const [error, setError] = useState(null);

  useEffect(() => {
    setFormData({
      customer_number: '',
      customer_name: '',
      home_page: '',
      limit_access: '',
      title_graphic: '',
      products: '',
      greeting: '',
      pay_tax_message: '',
      disable_message: '',
      county_number: '',
      accept_delinquents: '1',
      current_year_delinquents: 'false',
      import_payment: 'false',
      new_experience: 'false',
      disable_list: '',
      ip_access_list: '',
      taxid_block_list: '',
      paydelq: '',
      active: 'Yes',
      tax_search_message: '',
      payment_gateway: ''
    });
  }, [dataClient]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        ...formData,
        id: null,
      };

      const response = await apiClient.post(
        '/api/customer/create',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );

      if (response && response.data && response.data.result && response.data.result.message) {
        console.log(response.data.result.message);
        const message = response.data.result.message;

        if (message.includes("ERROR")) {
          setError(message.includes("Duplicate") ? 'That customer number is unavailable.' : message);
        } else {
            navigate(`/customer/${customerId}/client/list`);
        }
      } else {
        navigate(`/customer/${customerId}/client/list`);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setError('An error occurred while submitting the form.');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="customer-form">
      {error && <div className="error">{error}</div>}
      <table className="tableMain" border="0" width="100%" cellPadding="2" cellSpacing="2">
        <tbody>
          <tr>
            <td className="lbltxt">Customer Number:</td>
            <td>
              <input
                type="text"
                name="customer_number"
                value={formData.customer_number}
                onChange={handleInputChange}
                className="inputFull fieldsMed"
              />
            </td>
          </tr>
          <tr>
            <td className="lbltxt">Customer Name:</td>
            <td>
              <input
                type="text"
                name="customer_name"
                value={formData.customer_name}
                onChange={handleInputChange}
                className="inputFull fieldsMed"
              />
            </td>
          </tr>
          <tr>
            <td className="lbltxt">Home Page:</td>
            <td>
              <input
                type="text"
                name="home_page"
                value={formData.home_page}
                onChange={handleInputChange}
                className="inputFull fieldsMed"
              />
            </td>
          </tr>
          <tr>
            <td className="lbltxt">Products:</td>
            <td>
              <input
                type="text"
                name="products"
                value={formData.products}
                onChange={handleInputChange}
                className="inputFull fieldsMed"
              />
            </td>
          </tr>
          <tr>
            <td className="lbltxt">Greeting:</td>
            <td>
              <textarea
                name="greeting"
                className="inputFull fieldsMed"
                value={formData.greeting}
                onChange={handleInputChange}
              ></textarea>
            </td>
          </tr>
          <tr>
            <td className="lbltxt">Tax Payment Message:</td>
            <td>
              <textarea
                name="pay_tax_message"
                className="inputFull fieldsMed"
                value={formData.pay_tax_message}
                onChange={handleInputChange}
              ></textarea>
            </td>
          </tr>
          <tr>
            <td className="lbltxt">Disable Message:</td>
            <td>
              <textarea
                name="disable_message"
                className="inputFull fieldsMed"
                value={formData.disable_message}
                onChange={handleInputChange}
              ></textarea>
            </td>
          </tr>
          <tr>
            <td className="lbltxt">County Number:</td>
            <td>
              <input
                type="text"
                name="county_number"
                value={formData.county_number}
                onChange={handleInputChange}
                className="inputFull fieldsMed"
              />
            </td>
          </tr>
          <tr>
            <td className="lbltxt">Active:</td>
            <td>
              <select
                name="active"
                value={formData.active}
                onChange={handleInputChange}
                className="inputFull fieldsSm"
              >
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              {user?.role_name === "Admin" || user?.role_name === "SuperAdmin" ? (
                <button type="submit" className="fieldsMed">
                  Create Customer
                </button>
              ) : (
                <div></div>
              )}
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  );
};

export default NewCustomerForm;